import {
  File,
  FileSpreadsheet,
  FileText,
  Image as ImageIcon,
  Play,
} from 'lucide-react';

import { FileTypeCategory, getFileCategory } from '../constants/mime-types';

interface FileTypeIconProps {
  mimeType: string;
  className?: string;
}

export function FileTypeIcon({
  mimeType,
  className = 'h-8 w-8',
}: FileTypeIconProps) {
  const category = getFileCategory(mimeType);

  switch (category) {
    case FileTypeCategory.IMAGE:
      return (
        <ImageIcon
          className={`text-blue-500 dark:text-blue-400 ${className}`}
        />
      );
    case FileTypeCategory.PDF:
      return (
        <FileText className={`text-red-500 dark:text-red-400 ${className}`} />
      );
    case FileTypeCategory.VIDEO:
      return (
        <Play className={`text-purple-500 dark:text-purple-400 ${className}`} />
      );
    case FileTypeCategory.SPREADSHEET:
      return (
        <FileSpreadsheet
          className={`text-green-500 dark:text-green-400 ${className}`}
        />
      );
    case FileTypeCategory.DOCUMENT:
      return (
        <FileText className={`text-blue-500 dark:text-blue-400 ${className}`} />
      );
    default:
      return <File className={`text-muted-foreground ${className}`} />;
  }
}
